import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { makeStyles } from '@material-ui/core'
import Icon from '../../../../components/atoms/Icon'

const useStyles = makeStyles((theme) => ({
  navIconButton: {
    // marginTop: '-2px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 'var(--padding-xs)',
    borderRadius: 'var(--border-radius-md)',
    transition: 'background-color var(--transition-duration-medium) var(--transition-easing-normal)',
    '&:hover': {
      backgroundColor: 'color-mix(in srgb, var(--color-neutral-900) 25%, transparent)'
    }
  }
}))

function NavIconButton ({ icon, onClick, className, style, size, onHover }) {
  const classes = useStyles()

  return (
    <div
      className={clsx(classes.navIconButton, className)}
      style={style}
      onClick={onClick}
      onMouseEnter={() => onHover?.(true)}
      onMouseLeave={() => onHover?.(false)}
    >
      <Icon name={icon} customSize={size} />
    </div>
  )
}

NavIconButton.propTypes = {
  icon: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onClick: PropTypes.func,
  className: PropTypes.string,
  style: PropTypes.object,
  onHover: PropTypes.func
}

export default NavIconButton
